/**
 * @file  chat.ts
 * @description  widget for co-browsing and chat support on the site
 *
 * @author ogarcia (ozkary)
 * @date 11/072022
 */

/**
 * configure the site key on the env file. Make sure update the env file for the deployment step
 */
const chatKey = process.env.REACT_APP_CHAT;

/**
 * call to bootstrap the widget on the body of the document
 * enable the key to show, remove it to hide the widget
 * @returns void
 */
const chat = (): void => {
  if (!chatKey) {
    return;
  }

  /**
   * bootstrap the widget to the document. Notice the site key
   */
  const path = encodeURIComponent(window.location.origin + window.location.pathname);
  const coreCall = document.createElement('script');
  coreCall.id = 'electron-chat-widget';
  coreCall.defer = true;
  coreCall.crossOrigin = 'anonymous';
  coreCall.setAttribute('async', '1');
  coreCall.src = `https://us.engage.app/api/ecs/v1/loader/da15e5ca-4c66-4450-b83a-a08d149db218.js?path=${path}`;
  document.body.appendChild(coreCall);
};

/**
 * export the boot strappping function
 * @usage chat()
 */
export default chat;
